import PropTypes from 'prop-types';

const expensePaymentTeamReport = PropTypes.shape({
  totalCount: PropTypes.number.isRequired,
  totalPrice: PropTypes.number.isRequired,
});

export default expensePaymentTeamReport;
